// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file actions/v1/workflow_dispatch_definition.proto (package github.actions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file actions/v1/workflow_dispatch_definition.proto.
 */
export const file_actions_v1_workflow_dispatch_definition: GenFile = /*@__PURE__*/
  fileDesc("Ci1hY3Rpb25zL3YxL3dvcmtmbG93X2Rpc3BhdGNoX2RlZmluaXRpb24ucHJvdG8SEWdpdGh1Yi5hY3Rpb25zLnYxIvYCCiJXb3JrZmxvd0Rpc3BhdGNoRGVmaW5pdGlvblJlc3BvbnNlEhUKDXdvcmtmbG93X3BhdGgYASABKAkSFAoMc2VsZWN0ZWRfcmVmGAIgASgJEkUKEXNlbGVjdGVkX3JlZl90eXBlGAMgASgOMiouZ2l0aHViLmFjdGlvbnMudjEuV29ya2Zsb3dEaXNwYXRjaFJlZlR5cGUSEwoLZGVmYXVsdF9yZWYYBCABKAkSRAoQZGVmYXVsdF9yZWZfdHlwZRgFIAEoDjIqLmdpdGh1Yi5hY3Rpb25zLnYxLldvcmtmbG93RGlzcGF0Y2hSZWZUeXBlEhYKDndvcmtmbG93X3ZhbGlkGAYgASgIEhQKDHRyaWdnZXJfcGF0aBgHIAEoCRIZChFzaG93X3dvcmtmbG93X3RpcBgIIAEoCBI4CgZpbnB1dHMYCSADKAsyKC5naXRodWIuYWN0aW9ucy52MS5Xb3JrZmxvd0Rpc3BhdGNoSW5wdXQisAEKFVdvcmtmbG93RGlzcGF0Y2hJbnB1dBIMCgRuYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEhAKCHJlcXVpcmVkGAMgASgIEhUKDWRlZmF1bHRfdmFsdWUYBCABKAkSOgoEdHlwZRgFIAEoDjIsLmdpdGh1Yi5hY3Rpb25zLnYxLldvcmtmbG93RGlzcGF0Y2hJbnB1dFR5cGUSDwoHb3B0aW9ucxgGIAMoCSqQAQoXV29ya2Zsb3dEaXNwYXRjaFJlZlR5cGUSKgomV09SS0ZMT1dfRElTUEFUQ0hfUkVGX1RZUEVfVU5TUEVDSUZJRUQQABIlCiFXT1JLRkxPV19ESVNQQVRDSF9SRUZfVFlQRV9CUkFOQ0gQARIiCh5XT1JLRkxPV19ESVNQQVRDSF9SRUZfVFlQRV9UQUcQAirDAgoZV29ya2Zsb3dEaXNwYXRjaElucHV0VHlwZRIsCihXT1JLRkxPV19ESVNQQVRDSF9JTlBVVF9UWVBFX1VOU1BFQ0lGSUVEEAASJQohV09SS0ZMT1dfRElTUEFUQ0hfSU5QVVRfVFlQRV9URVhUEAESJwojV09SS0ZMT1dfRElTUEFUQ0hfSU5QVVRfVFlQRV9TVFJJTkcQAhInCiNXT1JLRkxPV19ESVNQQVRDSF9JTlBVVF9UWVBFX05VTUJFUhADEicKI1dPUktGTE9XX0RJU1BBVENIX0lOUFVUX1RZUEVfQ0hPSUNFEAQSLAooV09SS0ZMT1dfRElTUEFUQ0hfSU5QVVRfVFlQRV9FTlZJUk9OTUVOVBAFEigKJFdPUktGTE9XX0RJU1BBVENIX0lOUFVUX1RZUEVfQk9PTEVBThAGYgZwcm90bzM");

/**
 * Response payload for an explicit JSON request to
 * GET /:owner/:repo/actions/manual.
 *
 * @generated from message github.actions.v1.WorkflowDispatchDefinitionResponse
 */
export type WorkflowDispatchDefinitionResponse = Message<"github.actions.v1.WorkflowDispatchDefinitionResponse"> & {
  /**
   * @generated from field: string workflow_path = 1;
   */
  workflowPath: string;

  /**
   * @generated from field: string selected_ref = 2;
   */
  selectedRef: string;

  /**
   * @generated from field: github.actions.v1.WorkflowDispatchRefType selected_ref_type = 3;
   */
  selectedRefType: WorkflowDispatchRefType;

  /**
   * @generated from field: string default_ref = 4;
   */
  defaultRef: string;

  /**
   * @generated from field: github.actions.v1.WorkflowDispatchRefType default_ref_type = 5;
   */
  defaultRefType: WorkflowDispatchRefType;

  /**
   * @generated from field: bool workflow_valid = 6;
   */
  workflowValid: boolean;

  /**
   * @generated from field: string trigger_path = 7;
   */
  triggerPath: string;

  /**
   * @generated from field: bool show_workflow_tip = 8;
   */
  showWorkflowTip: boolean;

  /**
   * @generated from field: repeated github.actions.v1.WorkflowDispatchInput inputs = 9;
   */
  inputs: WorkflowDispatchInput[];
};

/**
 * Describes the message github.actions.v1.WorkflowDispatchDefinitionResponse.
 * Use `create(WorkflowDispatchDefinitionResponseSchema)` to create a new message.
 */
export const WorkflowDispatchDefinitionResponseSchema: GenMessage<WorkflowDispatchDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_dispatch_definition, 0);

/**
 * @generated from message github.actions.v1.WorkflowDispatchInput
 */
export type WorkflowDispatchInput = Message<"github.actions.v1.WorkflowDispatchInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: bool required = 3;
   */
  required: boolean;

  /**
   * @generated from field: string default_value = 4;
   */
  defaultValue: string;

  /**
   * @generated from field: github.actions.v1.WorkflowDispatchInputType type = 5;
   */
  type: WorkflowDispatchInputType;

  /**
   * @generated from field: repeated string options = 6;
   */
  options: string[];
};

/**
 * Describes the message github.actions.v1.WorkflowDispatchInput.
 * Use `create(WorkflowDispatchInputSchema)` to create a new message.
 */
export const WorkflowDispatchInputSchema: GenMessage<WorkflowDispatchInput> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_dispatch_definition, 1);

/**
 * @generated from enum github.actions.v1.WorkflowDispatchRefType
 */
export enum WorkflowDispatchRefType {
  /**
   * @generated from enum value: WORKFLOW_DISPATCH_REF_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_REF_TYPE_BRANCH = 1;
   */
  BRANCH = 1,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_REF_TYPE_TAG = 2;
   */
  TAG = 2,
}

/**
 * Describes the enum github.actions.v1.WorkflowDispatchRefType.
 */
export const WorkflowDispatchRefTypeSchema: GenEnum<WorkflowDispatchRefType> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_dispatch_definition, 0);

/**
 * @generated from enum github.actions.v1.WorkflowDispatchInputType
 */
export enum WorkflowDispatchInputType {
  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_STRING = 2;
   */
  STRING = 2,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_NUMBER = 3;
   */
  NUMBER = 3,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_CHOICE = 4;
   */
  CHOICE = 4,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_ENVIRONMENT = 5;
   */
  ENVIRONMENT = 5,

  /**
   * @generated from enum value: WORKFLOW_DISPATCH_INPUT_TYPE_BOOLEAN = 6;
   */
  BOOLEAN = 6,
}

/**
 * Describes the enum github.actions.v1.WorkflowDispatchInputType.
 */
export const WorkflowDispatchInputTypeSchema: GenEnum<WorkflowDispatchInputType> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_dispatch_definition, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(WorkflowDispatchDefinitionResponseSchema, "8d02afb0be88")
registerSchemaHash(WorkflowDispatchInputSchema, "b396551df78a")
